import { IOrder } from "modules/order/domain/models/IOrder";
import { PixKind } from "modules/payment/domain/models/PixApprovedTransaction";

export const PENDING_PIX_INTERVAL_MS = 15_000;
export const PENDING_PIX_VERIFY_WINDOW_MS = 15 * 60_000;
export const PENDING_PIX_RESEND_WINDOW_MS = 25 * 60_000;
export const PENDING_PIX_LINK_DEADLINE_MS = 30 * 60_000;
export const PENDING_PIX_RETENTION_MS = 2 * 24 * 60 * 60_000;

/** PIX que usa id próprio e entra na fila de pendentes. */
export const isQueueablePix = (kind: PixKind | undefined, order: IOrder): boolean =>
	kind === "Payment" || (kind === "Recharge" && !order.isOfflineRecharge);
